import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f01864d6&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseRangeSliderButton: require('/home/vsts/work/1/a/NuxtApp/components/base/range-slider/Button.vue').default})
